import React, { useState, useRef } from "react";
import AuthInput from "../../shared/authinput";
import HorizontalLine from "../../shared/HorizontalLine";
import { Container } from "@mui/material";
import MainButton from "../../shared/Button";
import { Formik, Form, Field, ErrorMessage } from "formik";
import AuthLayout from "./AuthLayout";

import { useNavigate } from "react-router-dom";
import { isValidPhoneNumber } from "react-phone-number-input";
import {
  PhoneInputsMain,
  CustomLabel,
} from "../../shared/commonstyle/PhoneStyle";
import { OrText } from "../../shared/commonstyle/AuthStyle";
import CommonPhoneInputs from "../../shared/authinput/CommonPhoneInputs";
import { getCountryCallingCode } from "react-phone-number-input";
import { SIGNUP } from "../../../constants/apiEndPoints";
import httpRequest from "../../../axios/index";
import { toast } from "react-hot-toast";
import { SignUpvalidationSchema } from "../../../helpers/validations/Auth";
import facebookIcon from "../../../assets/images/facebookicon.svg";
import GoogleIcon from "../../../assets/images/GoogleIcon.svg";
import {
  handleFacebookLogin,
  HandleGoogleLogin,
  SocialLoginApi,
} from "../../../services/auth/SocialLogin";
import OAuthButton from "../../shared/oauthbutton";
import { loginSuccess } from "../../../redux/slice/user/UserSlice";
import { useDispatch } from "react-redux";

const SignUp = () => {
  const dispatch = useDispatch();
  const PhoneInputFoucs = useRef(null);
  const defaultCountryCode = "US";
  const [PhoneError, SetPhoneError] = useState(false);
  const [IsItEmail, SetIsEmail] = useState(true);
  const [Loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isLoadingGoogle, setIsLoadingGoogle] = useState(false);
  const [isLoadingFacebook, setIsLoadingFacebook] = useState(false);

  const handleChange = (value, event, form) => {
    SetPhoneError(false);
    if (event?.nativeEvent?.inputType === "deleteContentBackward" && !value) {
      event.preventDefault();
      return;
    }
    const isNonString = typeof value !== "string";
    if (isNonString || value === "") {
      form.setFieldValue("phoneNumber", value);
      form.setFieldError("phoneNumber", "");
    } else {
      form.setFieldValue("IsEmail", " ");
      const isValid = isValidPhoneNumber(value);
      form.setFieldValue("phoneNumber", value);
      form.setFieldError(
        "phoneNumber",
        isValid ? undefined : "Invalid phone number"
      );
    }
    const digitCount = value?.replace(/\D/g, "")?.length;
    if (digitCount !== undefined && digitCount === 1) {
      SetIsEmail(true);
      form.setFieldValue("IsEmail", digitCount);
    } else if (value === "" || value === undefined) {
      form.setFieldValue("IsEmail", "");
      SetIsEmail(true);
    }
  };

  const EmailOnChange = (value, form) => {
    form.setFieldValue("IsEmail", value);

    if (/^\d+$/.test(value) && value.length >= 2) {
      SetIsEmail(false);
      const phoneNumberValues = `+${getCountryCallingCode(
        defaultCountryCode
      )}${value}`;
      form.setFieldValue("IsEmail", " ");
      form.setFieldValue("phoneNumber", phoneNumberValues);
    } else {
      SetIsEmail(true);
      form.setFieldValue("phoneNumber", "");
    }
  };

  const handleSubmit = async (values, { resetForm }) => {
    const { phoneNumber, password, fullName, IsEmail } = values;

    if (IsEmail.trim()) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isValidEmail = emailRegex.test(IsEmail);
      if (!isValidEmail) {
        toast.error("Invalid email format");
        return;
      }
    }

    if (phoneNumber !== undefined && phoneNumber !== "") {
      const isValid = isValidPhoneNumber(phoneNumber);
      if (!isValid) {
        SetPhoneError(true);
        toast.error("Invalid phone number");
        return;
      }
    }

    const userObj = {
      name: fullName,
      password: password,
    };

    if (IsEmail !== "" && IsEmail !== null && phoneNumber === "") {
      userObj.email = IsEmail;
    } else {
      userObj.phone_number = phoneNumber;
    }

    try {
      setLoading(true);

      const resp = await httpRequest.post(SIGNUP, {
        user: userObj,
      });

      if (resp?.status === 200) {
        const verificationPath =
          IsEmail !== "" && IsEmail !== null && phoneNumber === ""
            ? `/verification?email=${values.IsEmail}`
            : `/verification?phone=${values.phoneNumber}`;

        navigate(verificationPath);
        toast.success("An email sent to you for verification.");
        resetForm();
      }
    } catch (error) {
      const errorMessage = (
        error?.response?.data?.message || "Something went wrong"
      ).replace("Validation failed: ", "");
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  //

  const LoginwithFacebook = async () => {
    try {
      setIsLoadingFacebook(true);
      const response = await handleFacebookLogin();

      if (response) {
        const resp = await SocialLoginApi({
          provider: "facebook",
          access_token: response?._tokenResponse?.oauthAccessToken,
          user: {
            email: response?._tokenResponse?.email,
            name: response?._tokenResponse?.displayName,
          },
        });

        if (resp.status === 200 && resp?.data?.message === "Success") {
          const user = resp?.data?.user;
          dispatch(loginSuccess(user));
          if (
            user?.user_type === null &&
            user?.status === "pending" &&
            user?.review_approved === false
          ) {
            navigate("/customer-type");
          } else if (
            user?.user_type !== null &&
            user?.status === "pending" &&
            user?.review_approved === false
          ) {
            navigate("/pending-appproval");
          } else if (
            user?.user_type !== null &&
            user?.status !== "pending" &&
            user?.review_approved
          ) {
            navigate("/delivery-home");
          }
        }
      }
    } catch (error) {
      toast.error(error || "Something went wrong");
    } finally {
      setIsLoadingFacebook(false);
    }
  };

  const LoginwithGoogleHandler = async () => {
    try {
      setIsLoadingGoogle(true);
      const response = await HandleGoogleLogin();
      if (response) {
        const resp = await SocialLoginApi({
          provider: "google",
          access_token: response?.user?.accessToken,
        });

        if (resp.status === 200 && resp?.data?.message === "Success") {
          const user = resp?.data?.user;
          dispatch(loginSuccess(user));
          if (
            user?.user_type === null &&
            user?.status === "pending" &&
            user?.review_approved === false
          ) {
            navigate("/customer-type");
          } else if (
            user?.user_type !== null &&
            user?.status === "pending" &&
            user?.review_approved === false
          ) {
            navigate("/pending-appproval");
          } else if (
            user?.user_type !== null &&
            user?.status !== "pending" &&
            user?.review_approved
          ) {
            navigate("/delivery-home");
          }
        }
      }
    } catch (error) {
      toast.error(error || "Something went wrong");
    } finally {
      setIsLoadingGoogle(false);
    }
  };

  return (
    <>
      <Container maxWidth="lg">
        <AuthLayout>
          <Formik
            initialValues={{
              fullName: "",
              phoneNumber: "",
              password: "",
              IsEmail: "",
            }}
            validationSchema={SignUpvalidationSchema}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form autocomplete="off">
                {IsItEmail ? (
                  <>
                    <CustomLabel>
                      What's your phone number or email?
                    </CustomLabel>
                    <PhoneInputsMain
                      className={
                        formik.touched.IsEmail &&
                        formik.errors.IsEmail &&
                        "is__error"
                      }
                    >
                      <Field
                        type="email"
                        name="IsEmail"
                        label="What's your phone number or email?"
                        placeholder="Enter phone number or email"
                      >
                        {({ field, form }) => (
                          <input
                            {...field}
                            onChange={(event) =>
                              EmailOnChange(event.target.value, form)
                            }
                            placeholder="Enter phone number or email"
                            autoComplete="off"
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="IsEmail"
                        component="span"
                        className="error"
                      />
                    </PhoneInputsMain>
                  </>
                ) : (
                  <PhoneInputsMain
                    className={
                      formik.touched.phoneNumber &&
                      formik.errors.phoneNumber &&
                      "is__error"
                    }
                  >
                    <CustomLabel>
                      What's your phone number or email?
                    </CustomLabel>
                    <Field name="phoneNumber">
                      {({ field, form }) => (
                        <CommonPhoneInputs
                          // {...field}

                          onChange={(value, event) =>
                            handleChange(value, event, form)
                          }
                          value={formik.values.phoneNumber}
                          ref={PhoneInputFoucs}
                        />
                      )}
                    </Field>

                    <ErrorMessage
                      name="phoneNumber"
                      component="span"
                      className="error"
                    />
                  </PhoneInputsMain>
                )}
                <Field
                  type="text"
                  name="fullName"
                  label="Full Name"
                  placeholder="Enter your name"
                  component={AuthInput}
                />
                <Field
                  type="password"
                  name="password"
                  label="Password"
                  placeholder="Enter your password"
                  maxLength={10}
                  component={AuthInput}
                  showIcon={true}
                />
                {PhoneError && (
                  <span
                    className="Phoneerror"
                    style={{ paddingLeft: "10px", color: "red" }}
                  >
                    Invalid phone number
                  </span>
                )}
                <MainButton
                  type="submit"
                  label="Create Account"
                  MT="60"
                  isLoading={Loading}
                />
              </Form>
            )}
          </Formik>
          <HorizontalLine />
          <OrText>OR</OrText>
          <OAuthButton
            label="Sign In with Google"
            imageUrl={GoogleIcon}
            onClick={LoginwithGoogleHandler}
            isLoading={isLoadingGoogle}
          />
          <OAuthButton
            label="Sign In with Facebook"
            imageUrl={facebookIcon}
            onClick={LoginwithFacebook}
            isLoading={isLoadingFacebook}
          />
        </AuthLayout>
      </Container>
    </>
  );
};

export default SignUp;
